import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// This component is used to force a re-render of element(s) when it mounts,
// which will only occur on the client side. This allows us to fix difficult
// SSR issues, but comes with a performance cost so should be used sparingly.

const ReRenderOnMount = ({ children, shouldReRender = true }) => {
  const [renderKey, setRenderKey] = useState('unmounted');

  useEffect(() => {
    if (shouldReRender) {
      setRenderKey('mounted');
    }
  }, [shouldReRender]);

  return <Fragment key={renderKey}>{children}</Fragment>;
};

ReRenderOnMount.propTypes = {
  children: PropTypes.node,
  shouldReRender: PropTypes.bool,
};

export default ReRenderOnMount;
